<template>
    <div class="element" :data-required="required" :class="{ [this.type] : true, error : error.error, success: !error.error && error.init }">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />
        <placeholderElement v-bind="resolveProps('placeholder', this)" :error="error" :value="this.input" />
        <stateElement v-bind="resolveProps('state', this)" :error="error" />
        <input
            ref="inputRef"
            type="text"
            class="input"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="!this.editing || this.readonly"
            :placeholder="`${this.show_placeholder ? placeholder + (required ? ' *' : '') : ''}`"
            :autocomplete="this.autocomplete"
            :maxlength="this.maxlength"
            :aria-describedby="error.error ? `error_${this.id}` : null"
            v-model="input"
            @keyup="validateWrapper"
            @blur="validateWrapper"
            @change="handleChange"
        />
        <errorElement v-bind="resolveProps('error', this)" :error="error" :errorId="`error_${this.id}`" />
        <tooltipElement v-bind="resolveProps('tooltip', this)" :inline="true" />
    </div>
</template>

<script>
import {defineComponent, ref, watch, inject, onMounted, computed} from "vue";

// Our form helpers
import useFieldValidation from "formbuilder/fields/_validation";
import { propDefaults, resolveProps } from "formbuilder/fields/_props";
import { validateEmail } from "helpers/_validate";

import labelElement from "formbuilder/elements/LabelElement.vue";
import stateElement from "formbuilder/elements/StateElement.vue";
import placeholderElement from "formbuilder/elements/PlaceholderElement.vue";
import errorElement from "formbuilder/elements/ErrorElement.vue";
import tooltipElement from "formbuilder/elements/TooltipElement.vue";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

import { observeElement } from "helpers/_observer";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        labelElement,
        stateElement,
        placeholderElement,
        errorElement,
        tooltipElement
    },
    setup(props, { emit }) {
		const inputRef = ref();
        let input = ref("");
        const {registerValidator, validate, error} = useFieldValidation();

        let wasEmail = validateEmail(props.value);
        watch(
            () => props.value,
            () => {
                input.value = props.value;
            },
            {
                immediate: true
            }
        );

        const required = computed(() => props.required);
        watch(
            () => props.required,
            () => {
                registerValidator(input, props);
            },
            {
                immediate: true
            }
        );


        const validateWrapper = (e) => {
            const target = e.currentTarget || e.target;
            if (validateEmail(input.value)) {
                wasEmail = true;
            }
            if (!wasEmail) return;
            validate(e);
        }

        // If we got a initial value, validate instantly
        props.value && validate();

        const placeholder = computed(() => props.translate ? trans(props.placeholder) : props.placeholder);

        const handleChange = () => {
            emit('value-change', {
                name: props.name,
                value: input.value
            });
        }

		const killswitch = inject("killswitch");
		onMounted(() => {
			if (props.readonly) {
				observeElement(inputRef.value, "value", (oldValue, newValue) => {
					if (props.value == newValue) return;
					console.error("DOM manipulation not allowed", oldValue, newValue);
					killswitch && killswitch();
				});
			}
		});

        return {
            trans,
            input,
			inputRef,
            error,
            resolveProps,
            validate,
            validateWrapper,
            required,
            placeholder,
            handleChange
        };
    },
}
</script>